<script setup lang="ts">
const { slice, index } = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
})
</script>

<template>
  <div class="ct-quote-with-shop-the-look__grid">
    <LookTile
      :look="slice.Look"
      :lazy="index > 0"
      :look-count="2"
      :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
      class="ct-quote-with-shop-the-look__look"
    />

    <div class="ct-quote-with-shop-the-look__content">
      <blockquote
        v-if="slice?.Quote"
        class="ct-quote-with-shop-the-look__quote"
      >
        {{ slice.Quote }}
      </blockquote>

      <!-- Added for PDP -->
      <p
        v-if="slice?.Description"
        class="ct-quote-with-shop-the-look__description"
      >
        {{ slice.Description }}
      </p>

      <img
        v-if="slice.Look?.ProductImage?.url"
        :src="slice.Look.ProductImage.url"
        :alt="slice.Look.ProductImage.alternativeText || ''"
        class="ct-quote-with-shop-the-look__image"
        :height="slice.Look.ProductImage.height"
        :width="slice.Look.ProductImage.width"
        loading="lazy"
        fetchpriority="low"
        decoding="async"
      >

      <AppLink
        v-if="slice?.Button?.Text && slice?.Button?.Link"
        :to="slice.Button.Link"
        class="ct-quote-with-shop-the-look__button"
      >
        {{ slice.Button.Text }}
      </AppLink>
    </div>
  </div>
</template>

<style>
@import url("~layers/components/Look/Quote.css");
</style>
